import React, { ReactNode, RefObject } from "react";
import ApiFilterableItem from "./ApiFilterableItem";
import ApiTreeFilterableItem from "./ApiTreeFilterableItem";
import { ColumnItem, FilterComponentType } from "../../../interfaces/overview";
import FilterableItem from "./FilterableItem";
import InputFilterItem from "./InputFilterItem";
import useStatusSelector from "../../../../common/menu/hooks/useStatusSelector";
import DateFilterItem from "./DateFilterItem";
import { OverviewType } from "../../../../app";

type Props = {
  overviewType: OverviewType;
  columnItem: ColumnItem;
  label: ReactNode;
  placeholder: string;
  renderRef: RefObject<HTMLDivElement | null>;
  isOpen: boolean;
  // These three come from `columnItem.metadata.filterAble`, which is an
  // untyped, per-customer backend config blob (`KeyByAny`), so the values are
  // only known at runtime. `filterComponentType` selects the branch below;
  // `options` is a *key* into the useStatusSelector result (e.g.
  // "statusOptions") for the SELECT branch, not an option list.
  filterComponentType?: FilterComponentType;
  mode?: "multiple";
  options?: string;
};

const FilterableItemSwitch = (props: Props) => {
  const filteringData = useStatusSelector(props.overviewType);

  switch (props.filterComponentType) {
    case FilterComponentType.API_SELECT:
      return <ApiFilterableItem {...props} />;
    case FilterComponentType.API_TREE_SELECT:
      return <ApiTreeFilterableItem {...props} />;
    case FilterComponentType.SELECT:
      return (
        // @ts-expect-error `filteringData` is indexed with a single-element
        // array, which JS coerces to the string key ("statusOptions") at
        // runtime. Kept verbatim to preserve behaviour — unwrapping it to
        // `filteringData[props.options]` would be the clearer equivalent.
        <FilterableItem {...props} options={filteringData[[props.options]]} />
      );
    case FilterComponentType.DATE:
      return <DateFilterItem {...props} />;
    default:
      return <InputFilterItem {...props} />;
  }
};

export default FilterableItemSwitch;
